import store from "@/store";

export class LoadingService {
  static getIsLoading(): boolean {
    const isLoading = store.getters["ui/isLoading"];
    return isLoading;
  }

  static startLoading(): void {
    store.commit("ui/setIsLoading", true);
  }
  static stopLoading() {
    store.commit("ui/setIsLoading", false);
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  static async CallLoads(func: Function) {
    this.startLoading();
    await func();
    this.stopLoading();
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  static async CallLoadsReturn(func: Function): Promise<object> {
    try {
      this.startLoading();
      const funcReturn = await func();
      this.stopLoading();
      return funcReturn;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      this.stopLoading();
    }
  }
}

export default LoadingService;
